import React from 'react'
import { motion, MotionConfig } from 'motion/react'
import MapView from './MapView'
import CloseButton from '../CloseButton'
import { closeButtonVariants } from '../TagFilter/filterAnimation'
import { overlayVariants } from './filterAnimation'

// Rendered inside AnimatePresence, so it stays until the overlay has faded out
const GeographicFilterOverlay = (props: { onClose: () => void }) => {
  const handleOutsideClick = (e: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
    const el = e.target as HTMLElement
    if (el.classList.contains('outside')) {
      props.onClose()
    }
  }

  return (
    <MotionConfig reducedMotion="user">
      <motion.div
        className="outside fixed left-0 top-0 flex size-full items-center justify-center bg-black"
        variants={overlayVariants}
        initial="hidden"
        animate="visible"
        exit="hidden"
        onClick={handleOutsideClick}
      >
        <MapView />
      </motion.div>
      <CloseButton
        // the css transition would trail behind every frame of the animation
        className="[transition:none]"
        variants={closeButtonVariants}
        initial="hidden"
        animate="visible"
        exit="hidden"
        onClick={props.onClose}
      />
    </MotionConfig>
  )
}

export default GeographicFilterOverlay
